import { useState } from "react";
import GoLiveToggle from "@/components/GoLiveToggle";
import { INTENTS, MOCK_PULSE } from "@/lib/mockData";
import { Shuffle, Zap } from "lucide-react";

const MODES = [
  { id: "manual", label: "Pick intents" },
  { id: "anything", label: "I'm up for anything" },
  { id: "decide_for_me", label: "Decide for me" },
];

const Live = () => {
  const [mode, setMode] = useState("manual");
  const [selected, setSelected] = useState(["casual_hang"]);

  return (
    <div className="pt-5" data-testid="live-page">
      <h1 className="font-heading font-black text-3xl mb-1">Go Live</h1>
      <p className="text-sm text-[#555555] mb-5">Tell the world you're up for something. We'll match you live.</p>

      <GoLiveToggle />

      <div className="mt-6 brutal-card p-5">
        <div className="label-mono mb-3">Mode</div>
        <div className="flex gap-2 flex-wrap">
          {MODES.map((m) => (
            <button
              key={m.id}
              onClick={() => setMode(m.id)}
              className={`brutal-border rounded-full px-3 py-1.5 text-sm font-bold ${
                mode === m.id ? "bg-[#0A0A0A] text-white" : "bg-white"
              }`}
              data-testid={`live-mode-${m.id}`}
            >
              {m.label}
            </button>
          ))}
        </div>

        {mode === "manual" && (
          <div className="mt-5">
            <div className="label-mono mb-2">What you're up for</div>
            <div className="flex flex-wrap gap-2">
              {INTENTS.map((i) => {
                const on = selected.includes(i.id);
                return (
                  <button
                    key={i.id}
                    onClick={() => setSelected(on ? selected.filter((x) => x !== i.id) : [...selected, i.id])}
                    className={`brutal-border rounded-full px-3 py-2 text-sm font-bold ${
                      on ? "bg-[#FFCC00]" : "bg-white"
                    }`}
                    data-testid={`live-intent-${i.id}`}
                  >
                    {i.emoji} {i.label}
                  </button>
                );
              })}
            </div>
          </div>
        )}

        {mode === "anything" && (
          <div className="mt-5 text-sm text-[#555555] flex gap-2 items-center">
            <Zap className="w-4 h-4" /> You'll match with any nearby activity.
          </div>
        )}

        {mode === "decide_for_me" && (
          <div className="mt-5 text-sm text-[#555555]">
            We'll infer from your past activities: <span className="font-bold">coffee, run, gym</span>.
          </div>
        )}

        <button className="brutal-btn bg-white w-full py-2.5 mt-5 flex items-center justify-center gap-2" data-testid="live-randomise">
          <Shuffle className="w-4 h-4" /> Randomise
        </button>
      </div>

      <div className="mt-6 brutal-card p-5 bg-[#FFFBEB]">
        <div className="label-mono mb-3">Live aggregation near you</div>
        <div className="grid grid-cols-2 gap-3">
          <Stat n={MOCK_PULSE.available_now} label="People live" />
          <Stat n={MOCK_PULSE.nearby_count_10km} label="Within 10km" />
          <Stat n={12} label="Up for coffee" />
          <Stat n={6} label="Up for fitness" />
        </div>
      </div>
    </div>
  );
};

const Stat = ({ n, label }) => (
  <div className="brutal-card p-3 text-center bg-white">
    <div className="font-heading font-black text-2xl leading-none">{n}</div>
    <div className="label-mono text-[#555555] mt-1">{label}</div>
  </div>
);

export default Live;
